(() => {
  const dialog = document.querySelector('[data-first-order-dialog]');
  const launcher = document.querySelector('[data-first-order-open]');
  if (!dialog || !launcher || typeof dialog.showModal !== 'function') return;

  const dismissedKey = 'sp_first_order_dismissed_until';
  const shownKey = 'sp_first_order_shown';
  const week = 7 * 24 * 60 * 60 * 1000;
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, String(value)); } catch {} };
  const apply = dialog.querySelector('[data-first-order-apply]');
  const copy = dialog.querySelector('[data-first-order-copy]');
  const status = dialog.querySelector('[data-first-order-status]');
  const redirect = location.pathname + location.search;
  const discountRoute = new URL(apply.href).pathname;
  apply.href = discountRoute + '?redirect=' + encodeURIComponent(redirect);
  launcher.hidden = false;

  let interacted = false;
  let delayFinished = false;
  let automaticallyShown = read('sessionStorage', shownKey) === '1';
  let returnFocus = null;
  let previousOverflow = '';
  const busy = () => document.querySelector('dialog[open], [data-cart-drawer][aria-hidden="false"], .sp-quick-size:not([hidden]), .sp-size-guide.is-open, [data-filter-panel].is-open') || document.documentElement.classList.contains('sp-menu-open');
  const editing = () => document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');

  const open = (trigger = null) => {
    if (dialog.open || document.hidden || busy()) return false;
    returnFocus = trigger || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    status.textContent = '';
    dialog.showModal();
    dialog.querySelector('[data-first-order-close]').focus({ preventScroll: true });
    write('sessionStorage', shownKey, '1');
    automaticallyShown = true;
    return true;
  };
  const dismiss = () => {
    write('localStorage', dismissedKey, Date.now() + week);
    dialog.close();
  };
  const maybeOpen = () => {
    if (dialog.dataset.auto !== 'true' || !delayFinished || !interacted || automaticallyShown || editing() || Number(read('localStorage', dismissedKey)) > Date.now()) return;
    open();
  };

  launcher.addEventListener('click', () => open(launcher));
  dialog.querySelectorAll('[data-first-order-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href]')).filter(element => element.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus?.isConnected && returnFocus !== document.body) returnFocus.focus({ preventScroll: true });
  });
  let backdropPressed = false;
  const outside = event => {
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  };
  dialog.addEventListener('pointerdown', event => { backdropPressed = outside(event); });
  dialog.addEventListener('click', event => { if (backdropPressed && outside(event)) dismiss(); backdropPressed = false; });
  apply.addEventListener('click', () => write('localStorage', dismissedKey, Date.now() + week));
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(dialog.dataset.code);
      status.textContent = dialog.dataset.copied;
    } catch {
      const code = dialog.querySelector('[data-first-order-code]');
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(code);
      selection?.removeAllRanges();
      selection?.addRange(range);
      code.focus({ preventScroll: true });
      status.textContent = dialog.dataset.copyFallback;
    }
  });
  const interact = () => { interacted = true; maybeOpen(); };
  window.addEventListener('scroll', interact, { passive: true });
  document.addEventListener('pointerup', interact);
  document.addEventListener('keydown', interact);
  document.addEventListener('visibilitychange', maybeOpen);
  window.setTimeout(() => { delayFinished = true; maybeOpen(); }, Math.max(5, Number(dialog.dataset.delay) || 8) * 1000);
})();
